import _asyncToGenerator from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import './VenueShortlist.css';
import React, { useEffect, useRef, useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get, getDictionaryItem, canUseDOM, getGlobalDictionaryTerm, getPageThemeColors, getColorByTheme } from '../../utils';
import IconStar from '../../resources/icons/star.svg';
import ShortlistBtn from '../atoms/ShortlistBtn/ShortlistBtn';
import DateRange from '../Listing/DateRange';
import FileUpload from './FileUpload';
import getListing from '../../utils/getListing';
import { getVenuesApi } from '../../utils/venues';
import { useLocation } from 'react-router-dom';
import { IconToggleArrowDown } from '../atoms/Icons';
import { tealiumClickFunc } from '../../utils/tealium';
import Recaptcha from '../Login/components/Recaptcha';
var VenueShortlist = function VenueShortlist(_ref) {
  var fields = _ref.fields,
    isOpen = _ref.isOpen,
    setOpen = _ref.setOpen,
    analytics = _ref.analytics,
    formIdModifier = _ref.formIdModifier;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var currentLang = get(sitecoreContext, 'language');
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  var indexVenues = get(sitecoreContext, 'configuration.indexValues.venues') || 'qa_venues_en';
  var apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  var venueThankYouPage = get(sitecoreContext, 'configuration.venueThankYouPage') || '/';
  var closeVenuesLabel = getGlobalDictionaryTerm(sitecoreContext, 'closeVenuesLabel') || 'Close venues';
  var contentBody = useRef();
  var removeVenueFromShortlistAnalytics = analytics.removeVenueFromShortlistAnalytics,
    shareYourShortlistAnalytics = analytics.shareYourShortlistAnalytics,
    requestProposalAnalytics = analytics.requestProposalAnalytics,
    yourShortlistedBottomAnalytics = analytics.yourShortlistedBottomAnalytics,
    yourShortlistedTopAnalytics = analytics.yourShortlistedTopAnalytics,
    interactionWithVenueRPFormAnalytics = analytics.interactionWithVenueRPFormAnalytics;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isInteractionAvaialble = _useState2[0],
    setIsInteractionAvaialble = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    cards = _useState4[0],
    setCards = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    loadNo = _useState6[0],
    setLoadNo = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    openBar = _useState8[0],
    setOpenBar = _useState8[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    loading = _React$useState4[0],
    setLoading = _React$useState4[1];
  var appLocation = useLocation();
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    appLocationPath = _React$useState6[0],
    setAppLocationPath = _React$useState6[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    formShare = _useState10[0],
    setFormShare = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    formShareError = _useState12[0],
    setFormShareError = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    formShareSent = _useState14[0],
    setFormShareSent = _useState14[1];
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    submittedCheck = _useState16[0],
    setSubmittedCheck = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    submitted = _useState18[0],
    setSubmitted = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    formFullName = _useState20[0],
    setFormFullName = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    formEmail = _useState22[0],
    setFormEmail = _useState22[1];
  var _useState23 = useState(''),
    _useState24 = _slicedToArray(_useState23, 2),
    formPhone = _useState24[0],
    setFormPhone = _useState24[1];
  var _useState25 = useState(''),
    _useState26 = _slicedToArray(_useState25, 2),
    formStartDate = _useState26[0],
    setFormStartDate = _useState26[1];
  var _useState27 = useState(''),
    _useState28 = _slicedToArray(_useState27, 2),
    formEndDate = _useState28[0],
    setFormEndDate = _useState28[1];
  var _useState29 = useState(),
    _useState30 = _slicedToArray(_useState29, 2),
    formNumberOfDelegates = _useState30[0],
    setFormNumberOfDelegates = _useState30[1];
  var _useState31 = useState(''),
    _useState32 = _slicedToArray(_useState31, 2),
    formEventName = _useState32[0],
    setFormEventName = _useState32[1];
  var _useState33 = useState(''),
    _useState34 = _slicedToArray(_useState33, 2),
    formCompanyName = _useState34[0],
    setFormCompanyName = _useState34[1];
  var _useState35 = useState(''),
    _useState36 = _slicedToArray(_useState35, 2),
    formComments = _useState36[0],
    setFormComments = _useState36[1];
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    formFiles = _useState38[0],
    setFormFiles = _useState38[1];
  var _useState39 = useState(''),
    _useState40 = _slicedToArray(_useState39, 2),
    formFullNameError = _useState40[0],
    setFormFullNameError = _useState40[1];
  var _useState41 = useState(''),
    _useState42 = _slicedToArray(_useState41, 2),
    formEmailError = _useState42[0],
    setFormEmailError = _useState42[1];
  var _useState43 = useState(''),
    _useState44 = _slicedToArray(_useState43, 2),
    formPhoneError = _useState44[0],
    setFormPhoneError = _useState44[1];
  var _useState45 = useState(''),
    _useState46 = _slicedToArray(_useState45, 2),
    formNumberOfDelegatesError = _useState46[0],
    setFormNumberOfDelegatesError = _useState46[1];
  var _useState47 = useState(''),
    _useState48 = _slicedToArray(_useState47, 2),
    formStartDateError = _useState48[0],
    setFormStartDateError = _useState48[1];
  var _useState49 = useState(false),
    _useState50 = _slicedToArray(_useState49, 2),
    formFilesError = _useState50[0],
    setFormFilesError = _useState50[1];
  var _useState51 = useState(''),
    _useState52 = _slicedToArray(_useState51, 2),
    recaptchaError = _useState52[0],
    setRecaptchaError = _useState52[1];
  var _useState53 = useState(''),
    _useState54 = _slicedToArray(_useState53, 2),
    recaptchaShareEmailError = _useState54[0],
    setRecaptchaShareEmailError = _useState54[1];
  var recaptchaRef = useRef(null);
  var recaptchaShareEmailRef = useRef(null);
  var _useState55 = useState([]),
    _useState56 = _slicedToArray(_useState55, 2),
    venueIds = _useState56[0],
    setVenueIds = _useState56[1];
  var _useState57 = useState(false),
    _useState58 = _slicedToArray(_useState57, 2),
    removedVenue = _useState58[0],
    setRemovedVenue = _useState58[1];
  var dictionaryValues = get(fields, 'dictionary.dictionary', {
    dictionaryValues: []
  });
  var venuesDictionaryValues = get(fields, 'dictionary.dictionaryVenues', {
    dictionaryValues: []
  });
  var requiredError = getDictionaryItem(venuesDictionaryValues, 'required') || '%required%';
  var invalidFormatError = getDictionaryItem(venuesDictionaryValues, 'invalidFormat') || '%invalidFormat%';
  var allowedEmailsAre10Error = getDictionaryItem(venuesDictionaryValues, 'allowedEmailsAre10') || '%allowedEmailsAre10%';
  var validateRecaptchaError = getDictionaryItem(venuesDictionaryValues, 'validateRecaptcha') || '%validateRecaptcha%';
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  var shortlistVenues = function shortlistVenues(hits) {
    setCards(hits.map(function (hit, index) {
      if (!!hit) {
        var category = hit.category;
        if (hit.category && hit.category.join) {
          category = hit.category.join(',');
        }
        return {
          category: category,
          title: hit.title,
          phone: hit.phone,
          email: hit.email,
          englishTitle: hit.englishTitle,
          url: hit.url,
          hotelStarRating: parseInt(hit.hotelStarRating),
          objectID: hit.objectID
        };
      } else {
        return {
          category: '',
          title: '',
          phone: '',
          email: '',
          englishTitle: '',
          url: '',
          hotelStarRating: 0,
          objectID: String(index)
        };
      }
    }));
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var isValid, recaptchaToken, validations, fileUploadData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isValid = !formFilesError;
            if (!recaptchaShareEmailRef.current) {
              _context.next = 5;
              break;
            }
            _context.next = 4;
            return recaptchaShareEmailRef.current.getRecaptchaToken();
          case 4:
            recaptchaToken = _context.sent;
          case 5:
            if (!recaptchaToken) {
              isValid = false;
              setRecaptchaShareEmailError(validateRecaptchaError);
            } else {
              setRecaptchaError('');
            }
            validations = [[formEmail, function (v) {
              return v.indexOf('@') > -1;
            }, setFormEmailError], [formFullName, function (v) {
              return /^[A-Za-z\u0621-\u064A ]+$/.test(v);
            }, setFormFullNameError], [formStartDate, function () {
              return true;
            }, setFormStartDateError], [formNumberOfDelegates, function () {
              return true;
            }, setFormNumberOfDelegatesError], [formFiles, function (v) {
              return !!v.length;
            }, setFormFilesError]];
            validations.forEach(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 3),
                value = _ref4[0],
                validator = _ref4[1],
                setError = _ref4[2];
              if (!value) {
                setError(requiredError);
                isValid = false;
              } else if (!validator(value)) {
                setError(invalidFormatError);
                isValid = false;
              }
            });
            fileUploadData = new FormData();
            fileUploadData.set('language', currentLang);
            fileUploadData.set('g-recaptcha-response', recaptchaToken);
            if (formFullName) {
              fileUploadData.set('fullName', formFullName);
            }
            if (formEmail) {
              fileUploadData.set('email', formEmail);
            }
            if (formPhone) {
              fileUploadData.set('phone', formPhone);
            }
            if (formStartDate) {
              fileUploadData.set('startDate', formStartDate);
            }
            if (formEndDate) {
              fileUploadData.set('endDate', formEndDate);
            }
            if (formNumberOfDelegates) {
              fileUploadData.set('numberOfDelegates', String(formNumberOfDelegates));
            }
            if (formEventName) {
              fileUploadData.set('eventName', formEventName);
            }
            if (formCompanyName) {
              fileUploadData.set('companyName', formCompanyName);
            }
            if (formComments) {
              fileUploadData.set('comments', formComments);
            }
            formFiles.forEach(function (file) {
              fileUploadData.append('file', file);
            });
            if (cards.length) {
              fileUploadData.set('venues', JSON.stringify(cards.map(function (card) {
                return {
                  title: Array.isArray(card.title) ? card.title[0] : card.title,
                  phone: card.phone,
                  email: card.email,
                  url: card.url
                };
              })));
            }
            setSubmitted(true);
            setLoading(true);
            if (cards.length) {
              cards.forEach(function (card) {
                tealiumClickFunc(requestProposalAnalytics, Array.isArray(card.title) ? card.title[0] : card.title);
              });
            }
            _context.next = 27;
            return fetch("".concat(apiGlobal, "/api/form/RequestProposal"), {
              method: 'post',
              body: fileUploadData
            }).then(function (res) {
              res.json().then(function (json) {
                if (res.status === 400) {
                  if (json.Email) {
                    setFormEmailError(requiredError);
                  }
                  if (json.FullName) {
                    setFormFullNameError(requiredError);
                  }
                  if (json.StartDate) {
                    setFormStartDateError(requiredError);
                  }
                  if (json.NumberOfDelegates) {
                    setFormNumberOfDelegatesError(requiredError);
                  }
                } else {
                  setFormEmailError('');
                  setFormFullNameError('');
                  setFormStartDateError('');
                  setFormNumberOfDelegatesError('');
                  setSubmitted(false);
                  if (canUseDOM) {
                    window.location.href = venueThankYouPage;
                  }
                }
                setLoading(false);
              });
            }).finally(function () {
              return setLoading(false);
            });
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleFormFiles = function handleFormFiles(e, currentFieldModel, fieldValue, fieldKey, defaultEvent, confirmValue) {
    var analytics = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
    triggerInteraction();
    setFormFiles(fieldValue);
  };
  var shareEmails = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      var recaptchaToken, fileUploadData;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (cards.length) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            if (formShare) {
              _context2.next = 5;
              break;
            }
            setFormShareError(requiredError);
            return _context2.abrupt("return");
          case 5:
            if (!(formShare.split(',').filter(function (v) {
              return v.indexOf('@') > -1;
            }).length > 10)) {
              _context2.next = 8;
              break;
            }
            setFormShareError(allowedEmailsAre10Error);
            return _context2.abrupt("return");
          case 8:
            if (!(formShare.indexOf('@') === -1)) {
              _context2.next = 11;
              break;
            }
            setFormShareError(invalidFormatError);
            return _context2.abrupt("return");
          case 11:
            if (!recaptchaRef.current) {
              _context2.next = 15;
              break;
            }
            _context2.next = 14;
            return recaptchaRef.current.getRecaptchaToken();
          case 14:
            recaptchaToken = _context2.sent;
          case 15:
            if (!recaptchaToken) {
              setRecaptchaError(validateRecaptchaError);
            } else {
              setRecaptchaError('');
            }
            fileUploadData = new FormData();
            fileUploadData.set('language', currentLang);
            fileUploadData.set('g-recaptcha-response', recaptchaToken);
            fileUploadData.set('emails', formShare);
            fileUploadData.set('venues', JSON.stringify(cards.map(function (card) {
              return {
                title: Array.isArray(card.title) ? card.title[0] : card.title,
                phone: card.phone,
                email: card.email,
                url: card.url
              };
            })));
            tealiumClickFunc(shareYourShortlistAnalytics);
            _context2.next = 24;
            return fetch("".concat(apiGlobal, "/api/form/shareShortlist"), {
              method: 'post',
              body: fileUploadData
            }).then(function (res) {
              res.json().then(function (json) {
                if (res.status === 400) {
                  // setFormShareError(requiredError);
                } else {
                  setFormShareSent(true);
                  setFormShareError('');
                  setFormShare('');
                }
              });
            });
          case 24:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function shareEmails(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  useEffect(function () {
    if (submittedCheck) {
      if (contentBody && contentBody.current) {
        var c = contentBody.current;
        if (formFullNameError || formEmailError || formNumberOfDelegatesError || formStartDateError) {
          c.scrollTop = c.querySelectorAll('.form-error')[0].previousSibling.previousSibling.offsetTop - c.previousSibling.offsetHeight - 15;
        } else if (c.querySelectorAll('.form-field__error').length) {
          c.scrollTop = c.querySelectorAll('.venue-shortlist__docs')[0].offsetTop - c.previousSibling.offsetHeight - 15;
        } else if (c.querySelectorAll('.lr__error').length) {
          c.scrollTop = c.querySelectorAll('.venue-shortlist__footer')[0].offsetTop - c.previousSibling.offsetHeight - 15;
        }
      }
    }
  }, [submittedCheck]);
  useEffect(function () {
    if (canUseDOM) {
      setVenueIds(JSON.parse(localStorage.getItem('shortlistVenues') || '[]'));
      if (document.body) {
        var primaryColor = selectedPrimaryColor;
        var color = getColorByTheme(selectedPrimaryColor);
        var activeColor = selectedPrimaryActiveColor;
        document.body.style.setProperty('--venue-table-background-color', primaryColor);
        document.body.style.setProperty('--venue-table-background-active-color', activeColor);
        document.body.style.setProperty('--venue-table-color', color);
      }
    }
  }, []);
  useEffect(function () {
    setTimeout(function () {
      setFormShareError('');
      setRecaptchaError('');
      setFormEmailError('');
      setFormPhoneError('');
      setFormFullNameError('');
      setFormStartDateError('');
      setFormNumberOfDelegatesError('');
    }, 300);
    if (canUseDOM) {
      var toggleFn = function toggleFn(event) {
        ['.venue-shortlist__close', '.venue-shortlist__back', '.venue-header__bar-btn'].forEach(function (className) {
          if (event.target.closest(className)) {
            event.preventDefault();
            setIsInteractionAvaialble(!isOpen);
            setOpen(!isOpen);
            if (className === '.main-navigation__shortlist') {
              tealiumClickFunc(yourShortlistedTopAnalytics);
            }
            if (className === '.venue-header__bar-btn') {
              tealiumClickFunc(yourShortlistedBottomAnalytics);
            }
          }
        });
      };
      window.addEventListener('click', toggleFn);
      return function () {
        window.removeEventListener('click', toggleFn);
      };
    }
  }, [isOpen]);
  useEffect(function () {
    if (canUseDOM) {
      var triggerUpdate = function triggerUpdate() {
        setLoadNo(loadNo + 1);
        if (canUseDOM) {
          var ids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
          if (venueIds.some(function (id) {
            return ids.indexOf(id) === -1;
          })) {
            setRemovedVenue(true);
          } else {
            setRemovedVenue(false);
          }
          setVenueIds(ids);
        }
      };
      document.body.addEventListener('shortlistVenues', triggerUpdate);
      return function () {
        document.body.removeEventListener('shortlistVenues', triggerUpdate);
      };
    }
  }, [isOpen, loadNo, venueIds]);
  useEffect(function () {
    if (canUseDOM) {
      var ids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
      if (ids.length) {
        var itemFilters = {
          filters: ids.map(function (id) {
            return "(objectID:".concat(id, ")");
          }).join(' OR '),
          facetFilters: [['type:Venue']],
          hitsPerPage: 100,
          page: 0
        };
        shortlistVenues(cards.filter(function (card) {
          return ids.indexOf(card.objectID) > -1;
        }));
        getListing(indexVenues, itemFilters, algoliaSettings).then(function (response) {
          shortlistVenues(response.hits);
        });
      } else {
        shortlistVenues([]);
      }
    }
  }, [loadNo]);
  useEffect(function () {
    if (canUseDOM) {
      var closeSidebar = function closeSidebar(event) {
        var notCaptchaBox = get(event.target, 'parentElement.parentElement') !== document.body;
        if (!event.target.closest('.venue-shortlist__container') && notCaptchaBox) {
          setIsInteractionAvaialble(false);
          setOpen(false);
        }
      };
      document.body.addEventListener('click', closeSidebar);
      return function () {
        document.body.removeEventListener('click', closeSidebar);
      };
    }
  }, []);
  useEffect(function () {
    if (canUseDOM) {
      getVenuesApi(sitecoreContext).then(function (response) {
        if (get(response, 'data.user.venues')) {
          var venues = get(response, 'data.user.venues', []);
          var ids = venues.map(function (v) {
            return v.venueId.split('-').join('');
          });
          localStorage.setItem('shortlistVenues', JSON.stringify(ids));
          document.body.dispatchEvent(new Event('shortlistVenues'));
        }
      });
    }
  }, []);
  useEffect(function () {
    if (appLocationPath !== '' && appLocation.pathname !== appLocationPath) {
      setOpenBar(false);
    }
    if (appLocationPath === '') {
      setAppLocationPath(appLocation.pathname);
    }
  }, [appLocation]);
  useEffect(function () {
    var timeout;
    var shortlistedVenues = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
    if (!!loadNo) {
      if (shortlistedVenues.length) {
        setOpenBar(true);
      }
      if (!cards.length) {
        timeout = setTimeout(function () {
          setOpenBar(false);
        }, 2000);
      }
    } else {
      timeout = setTimeout(function () {
        setOpenBar(false);
      }, 2000);
    }
    return function () {
      return clearTimeout(timeout);
    };
  }, [cards]);
  var triggerInteraction = function triggerInteraction() {
    if (isInteractionAvaialble) {
      setIsInteractionAvaialble(false);
      tealiumClickFunc(interactionWithVenueRPFormAnalytics);
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__container ".concat(isOpen ? 'venue-shortlist__container-open' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__title"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Back",
    className: "btn--reset venue-shortlist__back",
    tabIndex: isOpen ? 0 : -1,
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        setIsInteractionAvaialble(!isOpen);
        setOpen(!isOpen);
      }
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007CBA",
    fillRule: "nonzero",
    d: "M7.712 4a2.14 2.14 0 0 1-.284 2.927L4.996 9.045H19v1.913H4.996l2.432 2.116c.857.745.981 2.03.284 2.926L1 10l6.712-6z"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__title-text"
  }, getDictionaryItem(dictionaryValues, 'your shortlist') || 'Title', ' ', cards.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, "(", cards.length, ")") : null), /*#__PURE__*/React.createElement("button", {
    className: "btn--reset venue-shortlist__close",
    tabIndex: isOpen ? 0 : -1,
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        setIsInteractionAvaialble(!isOpen);
        setOpen(!isOpen);
      }
    },
    title: closeVenuesLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text"
  }, closeVenuesLabel), /*#__PURE__*/React.createElement("svg", {
    className: "",
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.974",
    height: "12.974",
    viewBox: "0 0 12.974 12.974"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.72,3.22l1.06,1.06L10.06,9l4.72,4.72-1.06,1.06L9,10.06,4.28,14.78,3.22,13.72,7.94,9,3.22,4.28,4.28,3.22,9,7.94l4.72-4.72Z",
    transform: "translate(-2.513 -2.513)",
    fill: "#007cba",
    stroke: "#007cba",
    "stroke-width": "1"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__body",
    ref: contentBody
  }, !!cards.length ? /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__desc"
  }, getDictionaryItem(dictionaryValues, 'how shortlist works') || '%how shortlist works%') : null, !cards.length ? /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__desc"
  }, getDictionaryItem(dictionaryValues, 'your shortlist is empty') || '%your shortlist is empty%') : null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__cards"
  }, cards.map(function (card) {
    return /*#__PURE__*/React.createElement("div", {
      className: "venue-shortlist__card",
      key: card.objectID
    }, /*#__PURE__*/React.createElement("div", {
      className: "venue-shortlist__card-category"
    }, card.category), /*#__PURE__*/React.createElement("div", {
      className: "venue-shortlist__card-title"
    }, card.title), /*#__PURE__*/React.createElement("div", {
      className: "venue-shortlist__card-stars"
    }, [/*#__PURE__*/React.createElement("img", {
      src: IconStar,
      alt: "Star1"
    }), /*#__PURE__*/React.createElement("img", {
      src: IconStar,
      alt: "Star2"
    }), /*#__PURE__*/React.createElement("img", {
      src: IconStar,
      alt: "Star3"
    }), /*#__PURE__*/React.createElement("img", {
      src: IconStar,
      alt: "Star4"
    }), /*#__PURE__*/React.createElement("img", {
      src: IconStar,
      alt: "Star5"
    })].slice(0, parseInt(card.hotelStarRating))), /*#__PURE__*/React.createElement(ShortlistBtn, {
      checked: true,
      id: card.objectID,
      sitecoreContext: sitecoreContext,
      title: card.title,
      analytics: {
        remove: removeVenueFromShortlistAnalytics
      }
    }));
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__line"
  }), formShareSent ? /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share"
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share-title"
  }, getDictionaryItem(venuesDictionaryValues, 'shareYourShortlist') || '%shareYourShortlist%'), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share-desc-link-title"
  }, getDictionaryItem(venuesDictionaryValues, 'shareThankYouMessage') || '%shareThankYouMessage%'), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share-desc-link",
    onClick: function onClick() {
      return setFormShareSent(false);
    }
  }, getDictionaryItem(venuesDictionaryValues, 'shareAgain') || '%shareAgain%', " ", /*#__PURE__*/React.createElement(IconToggleArrowDown, null)))) : null, !formShareSent ? /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share"
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share-title"
  }, getDictionaryItem(venuesDictionaryValues, 'shareYourShortlist') || '%shareYourShortlist%'), /*#__PURE__*/React.createElement("input", {
    value: formShare,
    onChange: function onChange() {},
    onInput: function onInput(e) {
      setFormShare(e.target.value);
    },
    autoComplete: "off",
    placeholder: getDictionaryItem(venuesDictionaryValues, 'enterEmailAddress') || '%enterEmailAddress%',
    type: "text",
    className: "venue-shortlist__share-input",
    tabIndex: isOpen ? 0 : -1
  }), formShareError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formShareError) : null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__share-desc"
  }, /*#__PURE__*/React.createElement("input", {
    type: "submit",
    onClick: shareEmails,
    className: "btn btn-secondary venue-shortlist__share-submit",
    value: getDictionaryItem(venuesDictionaryValues, 'share') || '%share%',
    tabIndex: isOpen ? 0 : -1
  }), /*#__PURE__*/React.createElement("span", null, getDictionaryItem(venuesDictionaryValues, 'emailFieldDescription') || '%emailFieldDescription%')), isOpen && /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaShareEmailError,
    ref: recaptchaShareEmailRef
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__line"
  }), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__req"
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__req-title"
  }, getDictionaryItem(venuesDictionaryValues, 'requestProposal') || '%requestProposal%'), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__req-desc"
  }, getDictionaryItem(venuesDictionaryValues, 'requestProposalDescription') || '%requestProposalDescription%'), /*#__PURE__*/React.createElement("label", {
    className: "venue-shortlist__req-label ".concat(formFullNameError ? 'venue-shortlist__req-label_error' : ''),
    htmlFor: "venue-shortlist__req-full-name-".concat(formIdModifier)
  }, getDictionaryItem(venuesDictionaryValues, 'fullName') || '%fullName%', " ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement("input", {
    value: formFullName,
    onChange: function onChange(e) {
      triggerInteraction();
      setFormFullName(e.target.value);
      setFormFullNameError('');
    },
    type: "text",
    id: "venue-shortlist__req-full-name-".concat(formIdModifier),
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), formFullNameError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formFullNameError) : null, /*#__PURE__*/React.createElement("label", {
    className: "venue-shortlist__req-label ".concat(formEmailError ? 'venue-shortlist__req-label_error' : ''),
    htmlFor: "venue-shortlist__req-email-".concat(formIdModifier)
  }, getDictionaryItem(venuesDictionaryValues, 'email') || '%email%', " ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement("input", {
    value: formEmail,
    onChange: function onChange(e) {
      triggerInteraction();
      setFormEmail(e.target.value);
      setFormEmailError('');
    },
    type: "email",
    autoComplete: "off",
    id: "venue-shortlist__req-email-".concat(formIdModifier),
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), formEmailError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formEmailError) : null, /*#__PURE__*/React.createElement("label", {
    className: "venue-shortlist__req-label ".concat(formPhoneError ? 'venue-shortlist__req-label_error' : ''),
    htmlFor: "venue-shortlist__req-phone-".concat(formIdModifier)
  }, getDictionaryItem(venuesDictionaryValues, 'phone') || '%phone%'), /*#__PURE__*/React.createElement("input", {
    value: formPhone,
    onChange: function onChange(e) {
      triggerInteraction();
      setFormPhone(e.target.value);
      setFormPhoneError('');
    },
    type: "text",
    id: "venue-shortlist__req-phone-".concat(formIdModifier),
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), formPhoneError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formPhoneError) : null, /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__date ".concat(formStartDateError ? 'venue-shortlist__date_error' : '', " ").concat(isOpen ? '' : 'd-none')
  }, /*#__PURE__*/React.createElement("span", {
    className: "venue-shortlist__req-label"
  }, getDictionaryItem(venuesDictionaryValues, 'evenDates') || '%evenDates%', " ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement(DateRange, {
    clearAlllFilters: true,
    fields: {
      name: 'Date Range',
      title: {
        jss: {
          value: getDictionaryItem(venuesDictionaryValues, 'selectDate') || '%selectDate%'
        }
      },
      fieldNameItem: {
        item: {
          filedName: {
            value: 'datesRange'
          }
        }
      },
      fieldTypeItem: {
        item: {
          fieldType: {
            value: 'Date Range'
          }
        }
      }
    },
    ignoreQueryString: true,
    clearAllCallback: function clearAllCallback() {
      setFormStartDate('');
      setFormEndDate('');
    },
    buttonBlue: true,
    pickDate: getDictionaryItem(venuesDictionaryValues, 'pickDate') || '%pickDate%',
    showLabel: getDictionaryItem(venuesDictionaryValues, 'show') || '%show%',
    resultsLabel: getDictionaryItem(venuesDictionaryValues, 'result') || '%result%',
    facetsName: ['datesRange'],
    clearAllLabel: getDictionaryItem(venuesDictionaryValues, 'clearAll') || '%clearAll%',
    setFilter: function setFilter(date, _, dateInit) {
      var _dateInit = _slicedToArray(dateInit, 2),
        startDate = _dateInit[0],
        endDate = _dateInit[1];
      setFormStartDateError('');
      var tzoffset = new Date().getTimezoneOffset() * 60000;
      if (startDate) {
        var startDateISO = new Date(startDate.getTime() - tzoffset).toISOString().split('T')[0];
        setFormStartDate(startDateISO);
      } else {
        setFormStartDate('');
      }
      if (endDate) {
        var endDateISO = new Date(endDate.getTime() - tzoffset).toISOString().split('T')[0];
        setFormEndDate(endDateISO);
      } else {
        setFormEndDate('');
      }
    },
    wrapperToggle: function wrapperToggle() {},
    setSubpanelLabel: function setSubpanelLabel() {},
    lang: currentLang,
    analytics: {
      filterAnalytics: interactionWithVenueRPFormAnalytics,
      filterShowResultsAnalytics: interactionWithVenueRPFormAnalytics,
      filterSelectDateAnalytics: interactionWithVenueRPFormAnalytics,
      filterClearAllDateAnalytics: interactionWithVenueRPFormAnalytics,
      params: {}
    },
    fullWidth: true
  })), /*#__PURE__*/React.createElement("div", null), formStartDateError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formStartDateError) : null, /*#__PURE__*/React.createElement("label", {
    className: "venue-shortlist__req-label ".concat(formNumberOfDelegatesError ? 'venue-shortlist__req-label_error' : ''),
    htmlFor: "venue-shortlist__req-no-of-del-".concat(formIdModifier)
  }, getDictionaryItem(venuesDictionaryValues, 'numberDelegates') || '%numberDelegates%', " ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement("input", {
    value: formNumberOfDelegates,
    onChange: function onChange(e) {
      triggerInteraction();
      setFormNumberOfDelegates(e.target.value ? parseInt(e.target.value) || 1 : undefined);
      setFormNumberOfDelegatesError('');
    },
    type: "text",
    id: "venue-shortlist__req-no-of-del-".concat(formIdModifier),
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), formNumberOfDelegatesError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formNumberOfDelegatesError) : null, /*#__PURE__*/React.createElement("label", {
    className: "venue-shortlist__req-label",
    htmlFor: "venue-shortlist__req-ev-name-".concat(formIdModifier)
  }, getDictionaryItem(venuesDictionaryValues, 'eventName') || '%eventName%'), /*#__PURE__*/React.createElement("input", {
    value: formEventName,
    onChange: function onChange(e) {
      triggerInteraction();
      setFormEventName(e.target.value);
    },
    type: "text",
    id: "venue-shortlist__req-ev-name-".concat(formIdModifier),
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), /*#__PURE__*/React.createElement("label", {
    className: "venue-shortlist__req-label",
    htmlFor: "venue-shortlist__req-com-name-".concat(formIdModifier)
  }, getDictionaryItem(venuesDictionaryValues, 'companyName') || '%companyName%'), /*#__PURE__*/React.createElement("input", {
    value: formCompanyName,
    onChange: function onChange(e) {
      triggerInteraction();
      setFormCompanyName(e.target.value);
    },
    type: "text",
    id: "venue-shortlist__req-com-name-".concat(formIdModifier),
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  }), /*#__PURE__*/React.createElement("label", {
    className: "venue-shortlist__req-label",
    htmlFor: "venue-shortlist__req-comments-".concat(formIdModifier)
  }, getDictionaryItem(venuesDictionaryValues, 'comments') || '%comments%'), /*#__PURE__*/React.createElement("textarea", {
    value: formComments,
    onChange: function onChange(e) {
      triggerInteraction();
      setFormComments(e.target.value);
    },
    rows: 7,
    id: "venue-shortlist__req-comments-".concat(formIdModifier),
    className: "venue-shortlist__req-input",
    tabIndex: isOpen ? 0 : -1
  })), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__line venue-shortlist__line-mr"
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(isOpen ? '' : 'd-none', " venue-shortlist__docs")
  }, /*#__PURE__*/React.createElement(FileUpload, {
    title: getDictionaryItem(venuesDictionaryValues, 'uploadEventProposal'),
    changeHandler: handleFormFiles,
    onChangeError: function onChangeError(error) {
      return setFormFilesError(error);
    },
    placeholderText: 'test',
    name: 'test',
    openParent: isOpen,
    submitted: submitted,
    validate: true,
    onChangeEvent: function onChangeEvent() {},
    itemId: "test-".concat(formIdModifier),
    fieldKey: 'test',
    defaultEvent: function defaultEvent() {},
    errors: [],
    singleFile: true,
    fullWidth: true,
    btnPrimaryClassName: 'btn-secondary',
    required: true,
    cssClass: 'test',
    labelCssClass: 'test',
    fileSizeUnit: 1000,
    formDictionaries: {},
    dictionary: fields.dictionary.dictionaryVenues
  }), formFilesError ? /*#__PURE__*/React.createElement("div", {
    className: "form-error"
  }, formFilesError) : null), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__line venue-shortlist__line-footer"
  }), /*#__PURE__*/React.createElement("div", {
    className: "venue-shortlist__footer"
  }, isOpen && /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  }), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary venue-shortlist__req-submit",
    onClick: onSubmit,
    tabIndex: isOpen ? 0 : -1
  }, getDictionaryItem(venuesDictionaryValues, 'submit') || '%submit%')))), loading && /*#__PURE__*/React.createElement("div", {
    className: "Listing Listing--loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null)))))), venueThankYouPage !== '/' ? /*#__PURE__*/React.createElement("div", {
    className: "venue-header__bar ".concat(openBar ? 'venue-header__bar_animated' : '', " ").concat(removedVenue && cards.length === 0 ? 'venue-header__bar_removed' : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: "venue-header__bar-title"
  }, removedVenue ? cards.length > 0 ? getDictionaryItem(dictionaryValues, 'venueUnshortlisted') || '%venueUnshortlisted%' : getDictionaryItem(venuesDictionaryValues, 'noVenuesInShortlist') || '%noVenuesInShortlist%' : getDictionaryItem(dictionaryValues, 'venue shortlisted') || '%venue shortlisted%'), cards.length > 0 ? /*#__PURE__*/React.createElement("button", {
    className: "btn venue-header__bar-btn",
    tabIndex: isOpen ? 0 : -1
  }, getDictionaryItem(dictionaryValues, 'your shortlist'), " (", cards.length, ")") : null) : null);
};
var commonStyles = "c15y9uzi";
var ltrStyles = "l1gtps9e";
var rtlStyles = "rel0g51";
var dateStylesLtr = "d60mhcn";
var dateStylesRtl = "d1lg0z12";
var StyledWrapper = function StyledWrapper(_ref6) {
  var children = _ref6.children,
    rtl = _ref6.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(rtl ? dateStylesRtl : dateStylesLtr),
    componentTabIndex: "disabled"
  }, children);
};
export default VenueShortlist;